import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import parameters from '@atlassian/jira-relay/src/__generated__/useRecentItemsQuery.graphql';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ObjectListFlyoutProps, Item } from '@atlassian/navigation-common/types';
import type { FlyoutCloseHandlerProp } from '@atlassian/entry-point-flyout';

type EntryPointParams = { cloudId: string; count: number };

export const recentFlyoutEntrypoint: EntryPoint<
	EntryPointComponent<
		Record<string, OperationType>,
		Record<string, never>,
		ObjectListFlyoutProps<Item<{}>> & FlyoutCloseHandlerProp,
		Record<string, never>
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-object-list-flyout-entrypoint-jira-recents" */ '@atlassian/global-side-navigation/flyout-menu-item-content'
			),
		{
			moduleId: 'objectListFlyoutEntrypointJiraRecents',
		},
	),
	getPreloadProps: ({ cloudId, count }: EntryPointParams) => ({
		queries: {
			recentMenuData: {
				parameters,
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				variables: {
					cloudId,
					count,
					keyword: '',
				},
			},
		},
	}),
});
